import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { MARGIN_GAP } from "../../../../lib/constants.js";

export default function UploaderDialog({
  handleFileChange,
  handleUpload,
  locales,
  onClose,
  show,
}) {
  return (
    <Dialog open={show} onClose={onClose}>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: MARGIN_GAP }}
      >
        <Typography>{locales["upload.instructions"]}</Typography>
        <TextField type="file" onChange={handleFileChange} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {locales["upload.success.cancel"]}
        </Button>
        <Button onClick={handleUpload} color="secondary">
          {locales["upload.success.upload"]}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
